<template>
  <div id="pageDashboard">
     <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xl9 lg12 md12 sm12 xs12>
          <plain-table></plain-table>
        </v-flex>
       <v-flex xl6 lg6 sm12 xs12>
          <plain-table-order></plain-table-order>
        </v-flex> 
        
        <v-flex xl2 lg3 sm12 xs12>
          <place-table></place-table>
        </v-flex>

         <v-flex xl3 lg3 sm12 xs12>
          <all-cars></all-cars>
        </v-flex>
      
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import PlainTable from "@/components/widgets/list/PlainTable"
import PlainTableOrder from "@/components/widgets/list/PlainTableOrder"
import PlaceTable from "@/components/widgets/list/tablePlaces"
import AllCars from "@/components/widgets/list/allcars"
const axios = require('axios');
import moment from 'moment'
export default {
  components: {
    PlainTable,
    PlainTableOrder,
    PlaceTable,
    AllCars
  },
  computed: {
    dateNow() {
      return this.store.state.dateNow
    },
    sortby(){
      return this.store.state.sortby
    }
  },
  watch:{
     sortby: {
      handler: function(newValue,oldValue) {
      this.sort = newValue;
      clearInterval(this.intervaltimer);
      this.intervaltimer = null;
      if(this.intervaltimer == null)this.intervaltimer = setInterval( () => { this.refresh(); },1000)
      },
      deep: true
    },
     dateNow: {
      handler: function(newValue,oldValue) {
      this.dataNow = newValue;
      clearInterval(this.intervaltimer)
      this.intervaltimer = null;
     if(this.intervaltimer == null) this.intervaltimer = setInterval( () => { this.refresh(); },2000)
      },
      deep: true
    },
  },
  data: () => ({
    selectedTab: "tab-1",
    intervaltimer:null,
    sort:this.store.state.sortby,
    dataNow:this.store.state.dateNow,
   
  }),
  
  mounted(){
     this.sort = "country";
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    this.dataNow = new Date().toISOString().substr(0, 10);
    if(this.intervaltimer == null)this.intervaltimer = setInterval( () => { this.refresh(); },2000)
},
beforeDestroy: function(){
 clearInterval(this.intervaltimer)
  },
  data() {
    return {
      dataNow:null,
      sort:null,
      intervaltimer:null,
      overlay:true,
    }
  },
methods:{
getCookie(cname){
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
 
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
    },
 refresh(){
  var data = this;
  var jwt = this.getCookie('jwt');
  axios.post('http://' + location.hostname + '/transportapp/php_file/validation_token.php', {
           jwt :jwt,
           data: data.dataNow,
           sortby:data.sort
    })
  .then(function (response) {
    if ( response.data.message == "access" ){
         data.store.state.routes = JSON.parse( response.data.routes );
         data.store.state.cars   = JSON.parse( response.data.cars );
        data.store.state.places = JSON.parse( response.data.places );
        data.store.state.allcars = JSON.parse(response.data.allcars);
        data.overlay = false;
    } else if ( response.data.message == "denied" ) {
        data.$router.push('/auth/login');
        clearInterval(data.intervaltimer)
    }
  })
 }
},
}
</script>
